"use client";

import { useRef, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { YOUZU_API_BASE_URL } from "@/constants/api";
import { createAccessToken } from "@/services/token.service";

interface RoomVisualizerSDKProps {
  catalogueId?: string;
}

export function RoomVisualizerSDK({ catalogueId }: RoomVisualizerSDKProps) {
  const visualizerRef = useRef<any>(null);

  useEffect(() => {
    // Ensure the visualizer element is available
    const visualizer = visualizerRef.current;
    if (!visualizer) return;

    visualizer.resolveToken = async () => {
      console.log("🔄 Resolving token via proxy...");
      try {
        const token = await createAccessToken({ catalogueId: catalogueId || undefined });
        console.log("✅ Token resolved successfully");
        return token;
      } catch (error) {
        console.error("❌ Failed to resolve token:", error);
        return null;
      }
    };
  }, [catalogueId]);

  return (
    <Card>
      <CardContent className="p-0">
        <div className="w-full" style={{ height: "600px" }}>
          <youzu-room-visualizer
            ref={visualizerRef}
            id="visualizer"
            api-base-url={YOUZU_API_BASE_URL}
            lang="en"
            currency="USD"
            style={{
              display: "block",
              height: "600px",
              width: "100%",
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
}
